import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PipelineActivityService } from '../../../pipeline/services/pipeline-activity.service';
import { NoDataActionType, NoDataSourceType, NoDataTypes } from '../../interfaces/no-data';
import { LoanCardContactDialogComponent } from '../loan-card-contact-dialog/loan-card-contact-dialog.component';

@Component({
    selector: 'app-loan-card-contacts',
    templateUrl: './loan-card-contacts.component.html',
    styleUrls: ['./loan-card-contacts.component.css'],
})
export class LoanCardContactsComponent implements OnInit, OnChanges {
    loading: boolean = false;
    data: any[];
    noDataSelection: NoDataTypes;

    @Input() loanNumber: string;
    constructor(private _activityService: PipelineActivityService, private dialog: MatDialog) {}

    ngOnInit(): void {
        this.noDataSelection = {
            action: NoDataActionType.emptySelect,
            searchTerm: 'Milestones',
            componentTitle: 'loan contacts',
            inputSource: NoDataSourceType.smallDataCard,
        };
    }

    ngOnChanges(changes: SimpleChanges) {
        this.load();
    }

    load() {
        this.loading = true;

        try {
            this._activityService.getLoanContacts(this.loanNumber).subscribe(
                (res) => {
                    this.data = res;
                    this.loading = false;
                },
                (error) => {
                    throw error;
                }
            );
        } catch (e) {
            this.loading = false;
            this.data = null;
        }
    }

    // Searches activityDetail.contacts for contact type matching param
    getContactName(contactType: string) {
        let nameValue;

        nameValue = this.data.find((c) => c.contactType === contactType);
        if (nameValue) {
            if (nameValue.contactName) nameValue = nameValue.contactName;
            else if (nameValue.contactCompany) nameValue = nameValue.contactCompany;
            else nameValue = null;
        } else nameValue = null;

        return nameValue;
    }

    openContact(c) {
        let data = {
            name: this.getContactName(c.contactType),
            identifier: c.identifier,
            email: c.contactEmail,
            type: c.contactType,
            loanNumber: this.loanNumber,
            borrower: this.getContactName('Borrower 1'),
            phone: c.contactCell,
        };

        this.dialog.open(LoanCardContactDialogComponent, { data: data });
    }
}
